import { ApiError } from "@/lib/apiClient";
import { InventoryState, Variant } from "@/types/models/product";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { resetStoreSpecificState } from "@/store/actions/storeActions";

const initialState: InventoryState = {
  items: [] as Variant[],
  loading: false,
  error: null,
  pagination: {
    page: 0,
    total: 0,
    pageSize: 10,
    totalPages: 0,
  },
  formState: {
    loading: false,
    success: false,
    error: null,
  },
};

const inventorySlice = createSlice({
  name: "inventory",
  initialState,
  reducers: {
    fetchInventoryRequest: (
      state,
      action: PayloadAction<{ page: number; pageSize: number }>,
    ) => {
      state.loading = true;
      state.error = null;
      state.pagination.page = action.payload.page;
    },
    fetchInventorySuccess: (
      state,
      action: PayloadAction<{
        list: Variant[];
        page: number;
        total: number;
        pageSize: number;
        totalPages: number;
      }>,
    ) => {
      state.items = action.payload.list;
      state.pagination.page = action.payload.page;
      state.pagination.total = action.payload.total;
      state.pagination.pageSize = action.payload.pageSize;
      state.pagination.totalPages = action.payload.totalPages;
      state.loading = false;
    },
    fetchInventoryFailure: (state, action: PayloadAction<ApiError>) => {
      state.error = action.payload;
      state.loading = false;
    },
    // update product status
    updateInventory: (
      state,
      action: PayloadAction<{
        product_id: string;
        variant_id: string;
        inventory: number;
      }>,
    ) => {
      if (
        !action.payload.product_id ||
        !action.payload.variant_id ||
        !action.payload.inventory
      ) {
        return;
      }
      state.formState.loading = true;
      state.formState.error = null;
    },
    updateInventorySuccess: (
      state,
      action: PayloadAction<{
        product_id: string;
        variant_id: string;
        inventory: number;
      }>,
    ) => {
      state.items = state.items.map((item) => {
        if (
          item.product_id === action.payload.product_id &&
          item.id === action.payload.variant_id
        ) {
          return {
            ...item,
            inventory: action.payload.inventory,
          };
        }
        return item;
      });
      state.formState.loading = false;
      state.formState.success = true;
      state.formState.error = null;
    },
    updateInventoryFailure: (state, action: PayloadAction<ApiError>) => {
      state.formState.loading = false;
      state.formState.error = action.payload;
      state.formState.success = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetStoreSpecificState, () => initialState);
  },
});

export const {
  fetchInventoryRequest,
  fetchInventorySuccess,
  fetchInventoryFailure,
  updateInventory,
  updateInventorySuccess,
  updateInventoryFailure,
} = inventorySlice.actions;

export default inventorySlice.reducer;
